import { translate as t } from "./locale";
interface ProjectListNavigationProps {
    backDisabled: boolean;
    createDisabled: boolean;
    createOnBack: boolean;
    onBack: () => void;
    onCreate: () => void;
}

export const ProjectListNavigation = ({
    backDisabled,
    createDisabled,
    createOnBack,
    onBack,
    onCreate,
}: ProjectListNavigationProps) => (
    <div className="projects-heading-actions">
        <button className="primary-button" disabled={createDisabled} onClick={onCreate} type="button">
            {t("Nowy projekt")}
        </button>
        <button className="secondary-button" disabled={backDisabled} onClick={onBack} type="button">
            {createOnBack ? t("Utwórz i wróć") : t("Powrót")}
        </button>
    </div>
);

interface ProjectSelectionActionsProps {
    deleting: boolean;
    onClear: () => void;
    onDelete: () => void;
    selectedCount: number;
}

export const ProjectSelectionActions = ({
    deleting,
    onClear,
    onDelete,
    selectedCount,
}: ProjectSelectionActionsProps) => (
    <div className="project-selection-actions" aria-label={t("Zarządzanie zaznaczeniem")}>
        <button
            className="secondary-button"
            disabled={deleting || !selectedCount}
            onClick={onClear}
            type="button"
        >
            {t("Wyczyść zaznaczenie")}
        </button>
        <button
            className="delete-selected-button"
            disabled={deleting || !selectedCount}
            onClick={onDelete}
            type="button"
        >
            {deleting ? t("Usuwanie…") : t("Usuń zaznaczone ({value0})", { value0: selectedCount })}
        </button>
    </div>
);
